const round2 = (n) => Math.round(n * 100) / 100;

// Custo unitário de insumos rateado por uma quantidade (carros/peças/horas).
// Devolve 0 quando não há quantidade, evitando divisão por zero.
export const custoUnitario = (insumos, quantidade) => {
  const qtd = Number(quantidade) || 0;
  if (qtd <= 0) return 0;
  return round2((Number(insumos) || 0) / qtd);
};
